module.exports = __webpack_public_path__ + "img/Lab-Icon.346a49db.png";